/**
 * Os artefatos registrados (E153.F2–F3, ADR-0104 §2.5): o que cada compositor registrou do caso,
 * do mais recente ao mais antigo, com a situação contra a última avaliação. A avaliação nova não
 * apaga: o artefato dela sai desatualizado, e a linha fica.
 */
import { Badge, Blueprint } from '@/components/ui';
import { codigoCurto, type ArtefatoData } from '@/lib/resultadoAuditado';

import { VARIANTE_DO_ARTEFATO, dataCurta, preencher, t } from './textos';

function Artefato({ a }: { a: ArtefatoData }): JSX.Element {
  const r = t.artefatos;
  const detalhes = [
    preencher(r.sobre, { rodada: a.avaliacao_versao }),
    preencher(r.layout, { layout: a.layout }),
    t.regime[a.regime],
    a.emissao_id !== null ? r.comEmissao : null,
    codigoCurto(a.bytes_sha256),
  ].filter((d): d is string => d !== null);
  return (
    <li
      className="border-t border-border py-sc-2 text-body-sm"
      data-testid="resultado-artefato"
      data-kind={a.kind}
      data-versao={a.versao}
      data-etapa={a.etapa}
      data-situacao={a.situacao}
    >
      <p className="text-fg">
        {t.kind[a.kind]} · {r.colunas.versao} {a.versao} · {t.etapaDoArtefato[a.etapa]} ·{' '}
        {t.aprovacao[a.aprovacao]}{' '}
        <Badge variant={VARIANTE_DO_ARTEFATO[a.situacao]}>{t.situacaoDoArtefato[a.situacao]}</Badge>
      </p>
      <p className="text-caption text-fg-muted">
        {r.colunas.registrado} {dataCurta(a.criada_em)} · {detalhes.join(' · ')}
      </p>
    </li>
  );
}

export function ArtefatosDoResultado({ artefatos }: { artefatos: ArtefatoData[] }): JSX.Element {
  return (
    <Blueprint
      as="section"
      className="space-y-sc-3 p-sc-6"
      data-testid="resultado-artefatos"
      data-total={artefatos.length}
      aria-labelledby="resultado-artefatos-titulo"
    >
      <div>
        <h2 id="resultado-artefatos-titulo" className="text-body-lg text-fg">
          {t.artefatos.titulo}
        </h2>
        <p className="mt-1 max-w-prose text-body-sm text-fg-muted">{t.artefatos.subtitulo}</p>
      </div>
      {artefatos.length === 0 ? (
        <p className="text-body-sm text-fg-muted" data-testid="resultado-artefatos-vazio">
          {t.artefatos.vazio}
        </p>
      ) : (
        <ul>
          {artefatos.map((a) => (
            <Artefato key={a.id} a={a} />
          ))}
        </ul>
      )}
    </Blueprint>
  );
}
